import { render, staticRenderFns } from "./AllSettingItem.vue?vue&type=template&id=9ddf8f76&scoped=true&"
import script from "./AllSettingItem.vue?vue&type=script&lang=js&"
export * from "./AllSettingItem.vue?vue&type=script&lang=js&"
import style0 from "./AllSettingItem.vue?vue&type=style&index=0&id=9ddf8f76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddf8f76",
  null
  
)

export default component.exports